import { useEffect, useState } from "react";
import { Box, InputLabel, TextField, IconButton } from "@mui/material";
import { Edit as EditIcon, Check as CheckIcon, Close as CloseIcon } from "@mui/icons-material";

const EditableLabel = ({ label, value, onSave, isFirst, showPen  }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    setInputValue(value);
  }, [value]); 

  const handleSave = () => {
    onSave(inputValue);
    setIsEditing(false);
  };

  const handleCancel = () => {
    setInputValue(value);
    setIsEditing(false);
  };

  return (
    <Box display="flex" alignItems="center" gap={1}>
      {isEditing ? (
        <Box mb={2}>
          <TextField
            size="small"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            autoFocus
          />
          <IconButton color="success" onClick={handleSave}>
            <CheckIcon />
          </IconButton>
          <IconButton color="error" onClick={handleCancel}>
            <CloseIcon />
          </IconButton>
        </Box>
      ) : (
        <>
          <InputLabel>{value || label}</InputLabel>
          {(isFirst && showPen === true) && (
          <IconButton onClick={() => setIsEditing(true)}>
            <EditIcon sx={{ cursor: "pointer", color: "#41c1ba", fontSize:"1rem" }}/>
          </IconButton>
          )}
        </>
      )}
    </Box>
  );
};

export default EditableLabel;
